import { Component, Input, EventEmitter } from '@angular/core';
import { FormBuilder, FormArray } from '@angular/forms';

import { GenericFieldset, IGenericFieldset, TConfig } from '../generic-fieldset.component';

import { FormBuilderService } from "libraries/service/formBuilder/formBuilder.service";

import _toString from 'lodash-es/toString';
import _filter from 'lodash-es/filter';
import _find from 'lodash-es/find';
import _findIndex from 'lodash-es/findIndex';

import { Yii } from "libraries/interfaces/Yii";
import { wenji } from "../../../../interfaces/IWenji";
/**
 * Traveller-fieldset
 * Generate a fieldset of needed fields
 * @extends GenericFieldset
 * @implements IGenericFieldset
 */
@Component({
    selector: 'age-fieldset',
    templateUrl: './age-fieldset.component.html',
    styleUrls: ['./age-fieldset.component.scss'],
})
export class AgeFieldsetComponent extends GenericFieldset implements IGenericFieldset {
    public Yii = Yii;
    public wenjiUi = wenji.ui;
    /** emitter */
    public eData: EventEmitter<string> = new EventEmitter();
    /** to replicate the fieldset */


    /** Group as to be FormArray */
    @Input()
    public group: FormArray;


    /** to replicate the fieldset */
    @Input()
    public nbItems: any;
    // /** to replicate the fieldset */

    /** traveller Content */
    @Input()
    public travellerItem: any;
    /** traveller Content */

    /** Config */
    @Input('config')
    public config: TConfig;

    @Input()
    public apisForm: boolean = true;
    /**
     * @type {Subscription}
     * @private subscription
     */

    /** used to stock nb of Travellers */
    private nbFields: number;
    /** Readonly context can't be modified. Define the context of the fieldset */
    public readonly context: string = 'traveller';

    public openApis: any = {};

    private index: any = {
        'adult': 0,
        'infant': 0,
        'child': 0
    };

    /** DI - Formbuilder */
    constructor(public fb: FormBuilder, public formBuilderService: FormBuilderService) {
        super(fb);
    }

    public options = [
        { label: Yii.t('wui-shared-js', 'M'), value: 'Mr' },
        { label: Yii.t('wui-shared-js', 'Mme'), value: 'Mrs' },
        { label: Yii.t('wui-shared-js', 'Mlle'), value: 'Ms' }
    ];

    public optionsType = [
        { label: Yii.t('wui-shared-js', 'Adulte'), value: 'adult' },
        { label: Yii.t('wui-shared-js', 'Enfant'), value: 'child' },
        { label: Yii.t('wui-shared-js', 'Bébé'), value: 'infant' }
    ];

    public translate = {
        'adult': Yii.t('wui-shared-js', 'Adulte'),
        'child': Yii.t('wui-shared-js', 'Enfant'),
        'infant': Yii.t('wui-shared-js', 'Bébé')
    };


    /**
     * GEt type of a traveller
     * @param {number} index
     * @returns {string}
     */
    getType(index: number): string {

        let traveller = this.group.get(_toString(index));

        let type = traveller.get('type');
        let typeValue = type.value;

        return typeValue

    }

    public getTranslation(index: number): string {
        return this.translate[this.getType(index).toLowerCase()];
    }

    /**
     * increment and return type index
     * @param _type
     * @returns {number}
     */
    getTypeIndex(index: number): number {
        let type = this.getType(index);
        let traveller = this.group.get(_toString(index));

        let list = _filter(this.group.value, { 'type': type });

        let indexFound = _findIndex(list, (o: any) => {
            return o.id === traveller.value.id
        });

        return indexFound + 1;
    }

    hasChildInfant(): boolean {
        let travellers = this.group.value;
        let output = false;

        if (_find(travellers, { 'type': 'child' })) {
            output = true;
        } else if (_find(travellers, { 'type': 'infant' })) {
            output = true;
        }

        return output;
    }
}
